import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=7973fd09&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/repos/irs/irs/frontend/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7973fd09', component.options)
    } else {
      api.reload('7973fd09', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=7973fd09&", function () {
      api.rerender('7973fd09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/SideBar.vue"
export default component.exports